import { useVacationDaysFormat } from "~components/shared/useVacationDaysFormat.ts";
import { useCurrentEmployee } from "~contexts/CurrentEmployeeContext/CurrentEmployeeContext.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext";
import type { VacationEntitlement } from "~generated";
import { AccountSummarySlide } from "./AccountSummarySlide";
import { TimeCard } from "./TimeCard";

type VacationSlideProps = {
  vacation: VacationEntitlement;
};

export function VacationSlide({ vacation }: VacationSlideProps) {
  const t = useTranslation();
  const { currentEmployee } = useCurrentEmployee();
  const vacationDays = useVacationDaysFormat();

  return (
    <AccountSummarySlide
      heading={
        <>
          <span>{t.vacationEntitlementInclCarryover}</span>
          <span>{vacationDays.format(vacation.entitlement_days)}</span>
        </>
      }
    >
      <TimeCard
        subdued
        label={t.vacationEntitlementTaken}
        {...vacationDays.parts(vacation.used_days)}
        tooltip={
          currentEmployee.is_white_collar_worker
            ? t.vacationEntitlementTakenTooltip
            : undefined
        }
      />
      <TimeCard
        subdued
        label={t.vacationEntitlementPlanned}
        {...vacationDays.parts(vacation.planned_days)}
        tooltip={t.vacationEntitlementPlannedTooltip}
      />
      <TimeCard
        label={t.vacationEntitlementRemaining}
        {...vacationDays.parts(vacation.remaining_days)}
      />
    </AccountSummarySlide>
  );
}
